import { useCallback, useRef, useState } from 'react';

/*
 * Deshacer / rehacer del editor. Guarda fotos del contenido (título, descripción e items) ANTES de
 * cada cambio. Escribir un título son decenas de cambios: los de la misma clave (la misma pregunta y
 * el mismo campo) seguidos con menos de 1 s entre sí cuentan como uno, igual que en Google Forms.
 */
const MAX_FOTOS = 50;
const JUNTAR_MS = 1000;

export default function useHistorial() {
  const pasado = useRef([]);
  const futuro = useRef([]);
  const ultima = useRef({ clave: null, t: 0 });
  const [, repintar] = useState(0);

  const registrar = useCallback((foto, clave) => {
    const ahora = Date.now();
    if (clave && ultima.current.clave === clave && ahora - ultima.current.t < JUNTAR_MS) {
      ultima.current.t = ahora;
      return;
    }
    ultima.current = { clave: clave || null, t: ahora };
    pasado.current.push(foto);
    if (pasado.current.length > MAX_FOTOS) pasado.current.shift();
    futuro.current = [];
    repintar((n) => n + 1);
  }, []);

  const deshacer = useCallback((actual) => {
    const foto = pasado.current.pop();
    if (!foto) return null;
    futuro.current.push(actual);
    ultima.current = { clave: null, t: 0 };
    repintar((n) => n + 1);
    return foto;
  }, []);

  const rehacer = useCallback((actual) => {
    const foto = futuro.current.pop();
    if (!foto) return null;
    pasado.current.push(actual);
    ultima.current = { clave: null, t: 0 };
    repintar((n) => n + 1);
    return foto;
  }, []);

  return {
    registrar,
    deshacer,
    rehacer,
    puedeDeshacer: pasado.current.length > 0,
    puedeRehacer: futuro.current.length > 0,
  };
}
